// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.currentPhoto__ubMZr {
  width: 50%;
  height: 364px;
  position: relative;
}
@media (max-width: 1200px) {
  .currentPhoto__ubMZr {
    height: 295px;
  }
}
@media (max-width: 800px) {
  .currentPhoto__ubMZr {
    height: 243px;
  }
}
.currentPhoto__ubMZr img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.labelImageType__Z82E0,
.labelInstapoints__cYq6c {
  position: absolute;
  top: 5px;
  left: 5px;
  padding: 5px 10px;
  border-radius: 10px;
  background: var(--segments-chips-toggle-surface-active);
  color: var(--tables-primary-row-text-main);
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 14px;
  text-transform: uppercase;
  box-shadow: 0 0 1px 0 rgba(12, 26, 75, 0.24), 0 3px 8px -1px rgba(50, 50, 71, 0.05);
}

.labelInstapoints__cYq6c {
  background: var(--segments-chips-toggle-surface-default);
  text-transform: capitalize;
  top: 30px;
  left: 5px;
  color: var(--tables-secondary-row-sub-title-text);
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/EditSensorGalleryModal/components/CurrentImage/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,UAAA;EACA,aAAA;EACA,kBAAA;AAzEF;AA2EE;EALF;IAMI,aAAA;EAxEF;AACF;AA0EE;EATF;IAUI,aAAA;EAvEF;AACF;AAyEE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;AAvEJ;;AA2EA;;EAEE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;EACA,mBAAA;EACA,uDAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,mFACE;AAzEJ;;AA6EA;EACE,wDAAA;EACA,0BAAA;EACA,SAAA;EACA,SAAA;EACA,iDAAA;AA1EF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.currentPhoto {\n  width: 50%;\n  height: 364px;\n  position: relative;\n\n  @media (max-width: 1200px) {\n    height: 295px;\n  }\n\n  @media (max-width: 800px) {\n    height: 243px;\n  }\n\n  img {\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n  }\n}\n\n.labelImageType,\n.labelInstapoints {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  padding: 5px 10px;\n  border-radius: 10px;\n  background: var(--segments-chips-toggle-surface-active);\n  color: var(--tables-primary-row-text-main);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 14px;\n  text-transform: uppercase;\n  box-shadow:\n    0 0 1px 0 rgba(12, 26, 75, 0.24),\n    0 3px 8px -1px rgba(50, 50, 71, 0.05);\n}\n\n.labelInstapoints {\n  background: var(--segments-chips-toggle-surface-default);\n  text-transform: capitalize;\n  top: 30px;\n  left: 5px;\n  color: var(--tables-secondary-row-sub-title-text);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"currentPhoto": `currentPhoto__ubMZr`,
	"labelImageType": `labelImageType__Z82E0`,
	"labelInstapoints": `labelInstapoints__cYq6c`
};
module.exports = ___CSS_LOADER_EXPORT___;
